import { GettersType } from "@/store/getters/type";
import { StoreType } from "@/interfaces/StoreType";

export default {
  [GettersType.GET_DEPARTAMENTOS]: (state: StoreType) => state.dep,
};
